import { render, staticRenderFns } from "./TikTokAddProfileDialog.vue?vue&type=template&id=993f4018&scoped=true"
import script from "./TikTokAddProfileDialog.vue?vue&type=script&lang=js"
export * from "./TikTokAddProfileDialog.vue?vue&type=script&lang=js"
import style0 from "./TikTokAddProfileDialog.vue?vue&type=style&index=0&id=993f4018&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "993f4018",
  null
  
)

export default component.exports